import React, { useState } from 'react';
import {
    Table, Thead, Tbody, Tr, Th, Td, chakra, TableCaption,
    Box, Select, Input, IconButton, Flex, useDisclosure,
} from '@chakra-ui/react'
import {
    TriangleDownIcon, TriangleUpIcon,
    ArrowLeftIcon, ArrowRightIcon,
} from '@chakra-ui/icons';
import { useTable, useSortBy, useFilters, usePagination } from 'react-table';
import { GoChevronRight, GoChevronLeft } from 'react-icons/go';
import { subscriptionColumns } from '../constants';
import UpdatePaymentMethod from './UpdatePaymentMethod';

const SubscriptionsTable = ({ tableData, subscriptions, billingMethods, setReload }) => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [selectedIndex, setSelectedIndex] = useState(-1);
    // const finalColumns = subscriptionColumns;
    // finalColumns[4]['cell'] = (props) => (
    //     // <Tooltip hasArrow label='Download' placement='top' shouldWrapChildren>
    //     <Button onClick={() => console.log(props.row)}></Button>
    //     // </Tooltip>
    // )

    // Define a default UI for filtering
    function DefaultColumnFilter() {
        return (<></>);
    }

    const defaultColumn = React.useMemo(
        () => ({
            Filter: DefaultColumnFilter,
        }), [])

    const data = React.useMemo(
        () => tableData, [tableData],
    );

    const columns = React.useMemo(
        () => subscriptionColumns(onOpen, setSelectedIndex), [onOpen],
    );

    const { getTableProps, getTableBodyProps, headerGroups, prepareRow, page,
        canPreviousPage,
        canNextPage,
        pageOptions,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        setPageSize,
        state: { pageIndex, pageSize }, } =
        useTable({
            columns, data, defaultColumn, initialState: { pageSize: 5 },
        }, useFilters, useSortBy, usePagination);


    return (
        <Box overflowX='auto'>
            <Table {...getTableProps()} variant='striped' colorScheme='gray' size='md'>
                <TableCaption placement='bottom'>
                    <Flex justifyContent={'center'} alignContent={'center'}>
                        <IconButton size='md' aria-label='Go to first page' variant='link'
                            onClick={() => gotoPage(0)} disabled={!canPreviousPage} icon={<ArrowLeftIcon />} />

                        <IconButton size='md' aria-label='Go to first page' icon={<GoChevronLeft />}
                            onClick={() => previousPage()} disabled={!canPreviousPage} variant='link' />
                        <chakra.span mx={3}>
                            Page{' '}
                            <strong>
                                {pageIndex + 1} of {pageOptions.length}
                            </strong>
                        </chakra.span>
                        <IconButton size='md' aria-label='Go to first page' icon={<GoChevronRight />}
                            onClick={() => nextPage()} disabled={!canNextPage} variant='link' />
                        <IconButton size='md' aria-label='Go to first page' variant='link'
                            onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage} icon={<ArrowRightIcon />} />
                        <chakra.span>
                            | Go to page:
                            <Input
                                size='xs'
                                w={10}
                                type='number'
                                defaultValue={pageIndex + 1}
                                onChange={e => {
                                    const page = e.target.value ? Number(e.target.value) - 1 : 0
                                    gotoPage(page)
                                }}
                            />
                        </chakra.span>
                        <Select size='xs' ml={5}
                            maxW={'100px'}
                            value={pageSize}
                            onChange={e => {
                                setPageSize(Number(e.target.value))
                            }}
                        >
                            {[5, 10, 15, 20].map(pageSize => (
                                <option key={pageSize} value={pageSize}>
                                    Show {pageSize}
                                </option>
                            ))}
                        </Select>
                    </Flex>
                </TableCaption>
                <Thead>
                    {headerGroups.map((headerGroup) => (
                        <Tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <Th
                                    {...column.getHeaderProps()}
                                    isNumeric={column.isNumeric}
                                >
                                    <chakra.span  {...column.getSortByToggleProps()}>
                                        {column.render('Header')}
                                        <chakra.span pl='4'>
                                            {column.isSorted ? (
                                                column.isSortedDesc ? (
                                                    <TriangleDownIcon aria-label='sorted descending' />
                                                ) : (
                                                    <TriangleUpIcon aria-label='sorted ascending' />
                                                )
                                            ) : null}
                                        </chakra.span>
                                    </chakra.span>
                                    <div>{column.canFilter ? column.render('Filter') : null}</div>
                                </Th>
                            ))}
                        </Tr>
                    ))}
                </Thead>
                <Tbody {...getTableBodyProps()}>
                    {page.map((row) => {
                        prepareRow(row)
                        return (
                            <Tr {...row.getRowProps()}>
                                {row.cells.map((cell) => (
                                    <Td {...cell.getCellProps()} isNumeric={cell.column.isNumeric}>
                                        {cell.render('Cell')}
                                    </Td>
                                ))}
                            </Tr>
                        )
                    })}
                </Tbody>
            </Table>
            {isOpen &&
                <UpdatePaymentMethod isOpen={isOpen} onClose={onClose}
                    subscriptions={subscriptions}
                    billingMethods={billingMethods}
                    selectedIndex={selectedIndex}
                    setReload={setReload}
                />
            }
        </Box>
    );
}

export default SubscriptionsTable;